import isEmpty from 'lodash/isEmpty'
import isNil from 'lodash/isNil'
import { RequestActionPrefix } from '../../request/types'
import * as RootUtils from '../../utils'
import * as FlashMessage from '../flash-message'
import * as RasaInput from '../rasa-input'
import * as Types from './types'

export const handleCsvFileChange = (
  updateModal: (field: Types.ModalField) => any,
  validator: Types.CsvFileValidator,
  files: any,
) => {
  if (files && files.length) {
    const file = files[0];
    const reader = new FileReader();
    reader.onload = (e: any) => {
      updateModal({name: 'name', value: file.name})
      const data = RootUtils.arrayBufferToString(e.target.result)
      if (isNil(data)) {
        updateModal({name: 'isValid', value: false})
        updateModal({name: 'message', value: 'Unable to load CSV file.  Try loading a smaller record set.'})
      } else if (isEmpty(data)) {
        updateModal({name: 'isValid', value: false})
        updateModal({name: 'message', value: 'CSV File is empty.'})
      } else {
        updateModal({name: 'content', value: window.btoa(data)})
        const csvResult = data.split(/\r|\n|\r\n/)
        try {
          const csvHeader = csvResult[0].split(',')
          const validatorResult: RasaInput.Validation  = validator(csvHeader)
          const nonEmptyResults = csvResult.filter((r: string) => !isEmpty(r))
          updateModal({name: 'isValid', value: !validatorResult.invalid})
          updateModal({
            name: 'message',
            value: validatorResult.invalid ?
                     validatorResult.message :
                      nonEmptyResults.length - 1 > 1000 ?
                        'Read ' + (nonEmptyResults.length - 1) +
                          ' records.  Files this large can take up to 1 hour to process.' :
                          'Read ' + (nonEmptyResults.length - 1) + ' records.'})
        } catch (err) {
          updateModal({name: 'isValid', value: false})
          updateModal({name: 'message', value: 'Unable to parse CSV file.  Please check its format.'})
        }
      }
    }
    reader.readAsArrayBuffer(file)
  } else {
    updateModal({name: 'isValid', value: false})
    updateModal({name: 'message', value: 'No file selected'})
    updateModal({name: 'file', value: null})
  }
}

export const handleLogoFileChange = (
  updateModal: (field: Types.ModalField) => any,
  flashMessage: FlashMessage.SetMessageActionCreator ,
  files: any,
) => {
  if (files && files.length) {

    const file = files[0]

    const reader1 = new FileReader()
    const reader2 = new FileReader()
    reader1.readAsDataURL(files[0])
    reader1.onload = (e: any) => {
      const image: HTMLImageElement = new Image()
      image.src = e.target.result;

      image.onload = () => {
        const height: number = image.height;
        const width: number = image.width;

        if ( width > 700 || height > 300) {
          updateModal({name: 'file', value: null})
          updateModal({name: 'name', value: null})
          if (flashMessage) {
            flashMessage('Image should not exceed 700px of width or 300px of height')
          }
        } else {
          updateModal({name: 'file', value: file})
          updateModal({name: 'name', value: file.name})
          reader2.onload = (event: any) => {
            const data = RootUtils.arrayBufferToString(event.target.result)
            updateModal({name: 'content', value: window.btoa(data)})
            updateModal({name: 'isValid', value: true})
          }
          reader2.readAsArrayBuffer(file)
        }
      }
    }

  } else {
    updateModal({name: 'isValid', value: false})
    updateModal({name: 'message', value: 'No File selected'})
    updateModal({name: 'file', value: null})
  }
}

export const resetModalConstant = (prefix: RequestActionPrefix) => `${prefix}_MODAL_RESET`
export const submitModalConstant = (prefix: RequestActionPrefix) => `${prefix}_MODAL_SUBMIT`
export const toggleModalConstant = (prefix: RequestActionPrefix) => `${prefix}_MODAL_TOGGLE`
export const closeModalConstant = (prefix: RequestActionPrefix) => `${prefix}_MODAL_CLOSE`
export const updateModalConstant = (prefix: RequestActionPrefix) => `${prefix}_MODAL_UPDATE`



// WEBPACK FOOTER //
// ./src/components/modal/utils.ts